import styled from 'styled-components';
import YouTubePlayer from 'react-player';

export const Section = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 150px 50px 100px;

  h2 {
    font-size: 30px;
    font-weight: 600;
    align-self: center;
  }

  p {
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 20px;
    color: #444;
    line-height: 25px;
  }

  @media (min-width: 768px) {
    padding-left: 70px;
    padding-right: 70px;

    h2 {
      font-size: 40px;
    }
  }

  @media (min-width: 1000px) {
    max-width: 1100px;
    margin: auto;

    h2 {
      font-size: 50px;
      align-self: flex-start;
    }

    p {
      align-self: flex-start;
    }
  }
`;

export const Anchor = styled.a`
  text-decoration: none;
  padding-bottom: 3px;
  color: #877edc;
  align-self: center;
  margin-bottom: 20px;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px dashed #877edc;
  }

  @media (min-width: 1000px) {
    align-self: flex-start;
  }
`;

export const Player = styled(YouTubePlayer)`
  width: 100% !important;
  height: 0 !important;
  padding-bottom: 56.25%;
  position: relative;
  border-style: solid;
  border-width: 2px;
  border-color: white;
  border-radius: 4px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  margin-bottom: 50px;

  & > div {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

export const Link = styled.a`
  text-decoration: none;
  font-weight: bold;
  color: #444444;
`;

export const Image = styled.img`
  width: 100%;
  max-width: 500px;
`;
